import axios from 'axios'
import app from '@/main'
// import { isEmpty } from 'lodash'
import { translateUrlParams } from '@/utils/url'
import QS from 'qs'
import { baseApiURL, H5_VERSION } from '@/utils/properties'
import { getLocalAppConfig } from '@/utils/storage'
import { DispatchErrorCollectEvent } from '@/utils/ErrorCollect/utils/CustomErrorEvent'

export const CancelToken = axios.CancelToken

let baseURL = baseApiURL
// if (location.host === 'h5sdktest.3698k.com') {
//     baseURL = 'http://apitest.3698k.com'
// }
console.log('baseURL', baseURL)
const request = axios.create({
    baseURL,
    timeout: 60000,
    messageSilent: false, // 结果code非0时是否静默消息
    pureParams: true, // 纯净传参，只有请求时的参数，不加上页面地址的或其它额外参数
    withCredentials: true,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
})

// translateUrlParams()
request.interceptors.request.use((config) => {
        const urlQuery = translateUrlParams(window.top.location.href)
        // if (isEmpty(urlQuery)) {
        //     return config
        // }
        const { params, data, ...restConfig } = config
        const queryKey = params ? 'params' : 'data'
        console.log('pureParams', config.pureParams)
        let queryValue = config.pureParams ? config[queryKey] : {
            // h5 版本
            h5_version: H5_VERSION,
            // 是H5游戏
            is_js: 1,
            // sdk 版本，默认0
            sdk_version: '0',
            ...getLocalAppConfig(),
            ...urlQuery,
            ...config[queryKey],
        }
        // console.log('|------------------------------------------|')
        // console.log('final query: ', queryValue)
        // console.log('|------------------------------------------|')
        if (queryKey === 'data') {
            queryValue = QS.stringify(queryValue)
        }
        return {
            ...restConfig,
            [queryKey]: queryValue,
        }
    },
    (error) => {
        return Promise.reject(error)
    },
)

request.interceptors.response.use((response) => {
    if (Number(response.data.code) !== 0) {
        DispatchErrorCollectEvent({
            error_type: 'REQUEST_FAIL',
            error_detail: response.data,
        })
        if (!response.config.messageSilent && Number(response.data.code) !== 520) {
            app.$toast(response.data.msg || '请求失败')
        }
    }
    return response.data
}, error => error)

export default request
